import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { postExcludedAssets, } from "../request/postExcludedAssets";
import { excludedAssetsKeyMaker } from "./useGetExcludedAssets";
const IDEMPOTENCY_DESCRIPTOR = "ExcludedSecurities:Update";
const usePostExcludedAssets = (portfolioPlanId, concretePortfolioId, config) => {
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (data) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postExcludedAssets(portfolioPlanId, concretePortfolioId, data, idempotencyKey, config);
        },
        onSuccess: () => {
            // invalidate GetExcludedSecurities query
            queryClient.invalidateQueries({
                queryKey: excludedAssetsKeyMaker(portfolioPlanId, concretePortfolioId),
            });
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePostExcludedAssets;
//# sourceMappingURL=usePostExcludedAssets.js.map